import React, {
    createContext,
    useContext,
    useState,
    ReactNode,
} from "react";

/* --------- типы --------- */

export type User = {
    id: string;
    name: string;
    email?: string;
    role?: "user" | "admin";
};

type UserContextType = {
    user: User | null;
    setUser: (user: User | null) => void;
    updateUser: (patch: Partial<User>) => void;
    logout: () => void;
};

/* --------- контекст --------- */

const UserContext = createContext<UserContextType | undefined>(undefined);

/* --------- провайдер --------- */

export const UserProvider = ({ children }: { children: ReactNode }) => {
    const [user, setUser] = useState<User | null>(null);

    const updateUser = (patch: Partial<User>) => {
        setUser(prev =>
            prev ? { ...prev, ...patch } : prev
        );
    };

    const logout = () => {
        setUser(null);
        // тут можно почистить localStorage / cookies
    };

    return (
        <UserContext.Provider value={{user, setUser, updateUser, logout,}} >
            {children}
        </UserContext.Provider>
    );
};

/* --------- хук --------- */

export const useUser = () => {
    const ctx = useContext(UserContext);

    if (!ctx) {
        throw new Error("useUser must be used within UserProvider");
    }

    return ctx;
};
